// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var LineStyle;
(function (LineStyle) {
    LineStyle[LineStyle["SimpleChart"] = 0] = "SimpleChart";
    LineStyle[LineStyle["DotChart"] = 1] = "DotChart";
    LineStyle[LineStyle["DotLineChart"] = 2] = "DotLineChart";
    LineStyle[LineStyle["IsoDotChart"] = 3] = "IsoDotChart";
    LineStyle[LineStyle["ShapedChart"] = 4] = "ShapedChart";
    LineStyle[LineStyle["ShapedDotChart"] = 5] = "ShapedDotChart";
    LineStyle[LineStyle["ShapedDoubleDotChart"] = 6] = "ShapedDoubleDotChart";
    LineStyle[LineStyle["HistogrammChart"] = 7] = "HistogrammChart";
    LineStyle[LineStyle["ArrowChart"] = 8] = "ArrowChart";
    LineStyle[LineStyle["HorizontalLine"] = 9] = "HorizontalLine";
    LineStyle[LineStyle["Ladder"] = 10] = "Ladder";
})(LineStyle || (LineStyle = {}));
